"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SET_PARENTAL_CONTROL_QUERY = "\n    mutation SetParentalControl($enabled: Boolean!) {\n      setParentalControl(enabled: $enabled)\n    }\n";
exports.default = SET_PARENTAL_CONTROL_QUERY;
//# sourceMappingURL=setParentalControl.js.map